import React from "react";


const LineIcon: React.FC<{ h?: number }> = ({h = 24}) =>
  <svg width="36" height="4" viewBox="0 0 36 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2H34" stroke="#E6E6E6" strokeWidth="4" strokeLinecap="round"/>
  </svg>;

export {LineIcon};